import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=6a1ac2c6&scoped=true"
import script from "./inventory.vue?vue&type=script&lang=js"
export * from "./inventory.vue?vue&type=script&lang=js"
import style0 from "./inventory.vue?vue&type=style&index=0&id=6a1ac2c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ac2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1ac2c6')) {
      api.createRecord('6a1ac2c6', component.options)
    } else {
      api.reload('6a1ac2c6', component.options)
    }
    module.hot.accept("./inventory.vue?vue&type=template&id=6a1ac2c6&scoped=true", function () {
      api.rerender('6a1ac2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wareHouse/inventory.vue"
export default component.exports